import React from "react";
import _ from "lodash";
import glamorous from "glamorous";
import ReactTable from "react-table";
import { Button } from "react-bootstrap";
import "react-tabs/style/react-tabs.css";
import Plus from "react-icons/lib/md/add";
import Loader from "react-loader";

import UsersModal from "./UsersModal";
import SearchBar from "../../vendor/signal-widgets/components/search-bar";
import { getColumns } from "./UsersColumns";
import { datatableThStyles, styleify } from "../../styles/table-styles";
import Colors from "../../styles/colors";
import { Roles } from "../auth/authorization";

export const ModalMode = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  BLOCK: "BLOCK",
  UNBLOCK: "UNBLOCK"
};

const Section = glamorous.section({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "1em"
});

export default class UsersView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchStr: "",
      user: null,
      modalMode: ModalMode.CREATE,
      showUsersModal: false
    };

    this.rowActionHandler = this.rowActionHandler.bind(this);
  }

  componentWillMount() {
    const {
      fetchRoles,
      fetchOrganizationMembers,
      currentOrganizationId
    } = this.props;
    fetchRoles();
    fetchOrganizationMembers(currentOrganizationId);
  }

  rowActionHandler(action, val) {
    switch (action) {
      case "UPDATE":
        this.setState({
          modalMode: ModalMode.UPDATE,
          user: val,
          showUsersModal: true
        });
        break;

      case "DELETE":
        //TODO: delete org
        this.setState({
          modalMode: ModalMode.DELETE,
          user: val,
          showUsersModal: true
        });
        break;

      case "CANCEL":
        this.setState({
          modalMode: ModalMode.CREATE,
          user: null,
          showUsersModal: false
        });
        break;

      case "BLOCK":
        this.setState({
          modalMode: ModalMode.BLOCK,
          user: val,
          showUsersModal: true
        });
        break;

      case "UNBLOCK":
        this.setState({
          modalMode: ModalMode.UNBLOCK,
          user: val,
          showUsersModal: true
        });
        break;

      default:
        break;
    }
  }

  addRoleToUsers(users, roles) {
    if (users && roles) {
      users.forEach(user => {
        roles.forEach(role => {
          if (
            role.hasOwnProperty("users") &&
            _.includes(role.users, user.user_id)
          ) {
            user["role"] = this.getTableRoleName(role.name);
          }
        });
      });
    }

    return users;
  }

  getTableRoleName(roleName) {
    switch (roleName) {
      case Roles.CARRIER_SYSTEM:
        return "Carrier System";
      case Roles.FREIGHTVERIFY_ADMIN:
        return "FreightVerify Admin";
      case Roles.ORGANIZATION_ADMIN:
        return "Organization Admin";
      case Roles.ORGANIZATION_USER:
        return "Organization User";
      case Roles.THIRD_PARTY_SYSTEM:
        return "Third-Party System";
      default:
        return "";
    }
  }

  render() {
    const { searchStr, showUsersModal, modalMode, user } = this.state;
    const {
      isOrganizationMembersLoaded,
      roles,
      organizationMembers,
      currentOrganizationId
    } = this.props;

    // filter bad data until it cleaned up
    let filteredUsers = organizationMembers
      ? _.filter(organizationMembers, function(o) {
          return o.name !== "<User Not Found>";
        })
      : [];

    /*let filteredUsers = !hasRole(Roles.FREIGHTVERIFY_ADMIN, roles)
      ? _.filter(users, { organization_id: currentOrganizationId })
      : //? _.filter(users, { organization_id: Number(currentOrganizationId) })
        users;*/
    filteredUsers = searchStr
      ? filteredUsers.filter(u => {
          return (
            (u.first_name &&
              u.first_name.toLowerCase().includes(searchStr.toLowerCase())) ||
            (u.last_name &&
              u.last_name.toLowerCase().includes(searchStr.toLowerCase())) ||
            (u.email && u.email.toLowerCase().includes(searchStr.toLowerCase()))
          );
        })
      : filteredUsers;

    filteredUsers = this.addRoleToUsers(filteredUsers, roles);
    const columns = getColumns(this.rowActionHandler);

    const tableTrProps = () => {
      return {
        style: { cursor: "pointer" }
      };
    };

    return (
      <Section>
        <glamorous.Div
          css={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            marginTop: "1em"
          }}
        >
          <SearchBar
            placeholder={"Search for user"}
            searchStr={searchStr}
            eventHandler={(searchStr, type) => this.setState({ searchStr })}
          />
          <Button
            style={{
              backgroundColor: Colors.highlight.GREEN,
              color: "white",
              fontWeight: "300",
              height: "3em",
              marginLeft: "0.5em"
            }}
            onClick={() =>
              this.setState({
                showUsersModal: true,
                modalMode: ModalMode.CREATE,
                user: null
              })
            }
          >
            <Plus size="2em" /> Add New User
          </Button>
        </glamorous.Div>

        <Loader loaded={isOrganizationMembersLoaded} />
        <ReactTable
          data={filteredUsers}
          columns={columns}
          getTheadThProps={styleify(datatableThStyles)}
          getTrProps={tableTrProps}
        />
        <UsersModal
          show={showUsersModal}
          hide={() => this.setState({ showUsersModal: false, user: null })}
          modalMode={modalMode}
          user={user}
          roles={roles}
          currentOrganizationId={currentOrganizationId}
        />
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/users/UsersView.js